import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import logo from "./assets/Burakyol-logo.jpeg";

// Üsküdar proje fotoğrafları
import uskudar from "./assets/uskudar/uskudar.jpeg";
import uskudar1 from "./assets/uskudar/uskudar1.jpeg";
import uskudar2 from "./assets/uskudar/uskudar2.jpeg";
import uskudar3 from "./assets/uskudar/uskudar3.jpeg";
import uskudar4 from "./assets/uskudar/uskudar4.jpeg";
import uskudar5 from "./assets/uskudar/uskudar5.jpg";
import uskudar6 from "./assets/uskudar/uskudar6.jpg";
import uskudar7 from "./assets/uskudar/uskudar7.jpg";
import uskudar8 from "./assets/uskudar/uskudar8.jpg";
import uskudar9 from "./assets/uskudar/uskudar9.jpg";
import uskudar10 from "./assets/uskudar/uskudar10.jpg";
import uskudar11 from "./assets/uskudar/uskudar11.jpg";
import uskudar12 from "./assets/uskudar/uskudar12.jpg";
import uskudar13 from "./assets/uskudar/uskudar13.jpg";
import uskudar14 from "./assets/uskudar/uskudar14.jpeg";
import uskudar15 from "./assets/uskudar/uskudar15.jpeg";
import uskudar16 from "./assets/uskudar/uskudar16.jpeg";
import uskudar17 from "./assets/uskudar/uskudar17.jpeg";
import uskudar18 from "./assets/uskudar/uskudar18.jpeg";
import uskudar19 from "./assets/uskudar/uskudar19.jpeg";
import uskudar20 from "./assets/uskudar/uskudar20.jpeg";
import uskudar21 from "./assets/uskudar/uskudar21.jpeg";
import uskudar22 from "./assets/uskudar/uskudar22.jpeg";
import uskudar23 from "./assets/uskudar/uskudar23.jpeg";
import uskudar24 from "./assets/uskudar/uskudar24.jpeg";
import uskudar25 from "./assets/uskudar/uskudar25.jpeg";
import uskudar26 from "./assets/uskudar/uskudar26.jpeg";
import uskudar27 from "./assets/uskudar/uskudar27.jpeg";
import uskudar28 from "./assets/uskudar/uskudar28.jpeg";
import uskudar29 from "./assets/uskudar/uskudar29.jpeg";
import uskudar30 from "./assets/uskudar/uskudar30.jpeg";
import uskudar31 from "./assets/uskudar/uskudar31.jpeg";
import uskudar32 from "./assets/uskudar/uskudar32.jpeg";
import uskudar33 from "./assets/uskudar/uskudar33.jpeg";
import uskudar34 from "./assets/uskudar/uskudar34.jpeg";
import uskudar35 from "./assets/uskudar/uskudar35.jpeg";
import uskudar36 from "./assets/uskudar/uskudar36.jpeg";

// Kartal proje fotoğrafları
import kartal1 from "./assets/kartal/kartal-kentsel-donusum (1).jpg";
import kartal2 from "./assets/kartal/kartal-kentsel-donusum (2).jpg";
import kartal3 from "./assets/kartal/kartal-kentsel-donusum (3).jpg";
import kartal4 from "./assets/kartal/kartal-kentsel-donusum (4).jpg";
import kartal5 from "./assets/kartal/kartal-kentsel-donusum (5).jpg";
import kartal6 from "./assets/kartal/kartal-kentsel-donusum (6).jpg";
import kartal7 from "./assets/kartal/kartal-kentsel-donusum (7).jpg";
import kartal8 from "./assets/kartal/kartal-kentsel-donusum (8).jpg";
import kartal9 from "./assets/kartal/kartal-kentsel-donusum (9).jpg";
import kartal10 from "./assets/kartal/kartal-kentsel-donusum (10).jpg";
import kartal11 from "./assets/kartal/kartal-kentsel-donusum (11).jpg";
import kartal12 from "./assets/kartal/kartal-kentsel-donusum (12).jpg";
import kartal13 from "./assets/kartal/kartal-kentsel-donusum (13).jpg";
import kartal14 from "./assets/kartal/kartal-kentsel-donusum (14).jpg";
import kartal15 from "./assets/kartal/kartal-kentsel-donusum (15).jpg";
import kartal16 from "./assets/kartal/kartal-kentsel-donusum (16).jpg";
import kartal17 from "./assets/kartal/kartal-kentsel-donusum (17).jpg";
import kartal18 from "./assets/kartal/kartal-kentsel-donusum (18).jpg";
import kartal19 from "./assets/kartal/kartal-kentsel-donusum (19).jpg";
import kartal20 from "./assets/kartal/kartal-kentsel-donusum (20).jpg";
import kartal21 from "./assets/kartal/kartal-kentsel-donusum (21).jpg";
import kartal22 from "./assets/kartal/kartal-kentsel-donusum (22).jpg";
import kartal23 from "./assets/kartal/kartal-kentsel-donusum (23).jpg";
import kartal24 from "./assets/kartal/kartal-kentsel-donusum (24).jpg";
import kartal25 from "./assets/kartal/kartal-kentsel-donusum (25).jpg";
import kartal26 from "./assets/kartal/kartal-kentsel-donusum (26).jpg";
import kartal27 from "./assets/kartal/kartal-kentsel-donusum (27).jpg";
import kartal28 from "./assets/kartal/kartal-kentsel-donusum (28).jpg";
import kartal29 from "./assets/kartal/kartal-kentsel-donusum (29).jpg";
import kartal30 from "./assets/kartal/kartal-kentsel-donusum (30).jpg";
import kartal31 from "./assets/kartal/kartal-kentsel-donusum (31).jpg";
import kartal32 from "./assets/kartal/kartal-kentsel-donusum (32).jpg";
import kartal33 from "./assets/kartal/kartal-kentsel-donusum (33).jpg";
import kartal34 from "./assets/kartal/kartal-kentsel-donusum (34).jpg";
import kartal35 from "./assets/kartal/kartal-kentsel-donusum (35).jpg";
import kartal36 from "./assets/kartal/kartal-kentsel-donusum (36).jpg";
import kartal37 from "./assets/kartal/kartal-kentsel-donusum (37).jpg";
import kartal38 from "./assets/kartal/kartal-kentsel-donusum (38).jpg";
import kartal39 from "./assets/kartal/kartal-kentsel-donusum (39).jpg";
import kartal40 from "./assets/kartal/kartal-kentsel-donusum (40).jpg";
import kartal41 from "./assets/kartal/kartal-kentsel-donusum (41).jpg";

// Kiptaş proje fotoğrafları
import kiptas1 from "./assets/kiptas/kiptas.jpg";
import kiptas2 from "./assets/kiptas/kiptas2.jpeg";
import kiptas3 from "./assets/kiptas/kiptas3.jpeg";
import kiptas4 from "./assets/kiptas/kiptas4.jpeg";
import kiptas5 from "./assets/kiptas/kiptas5.jpeg";
import kiptas6 from "./assets/kiptas/kiptas6.jpeg";
import kiptas7 from "./assets/kiptas/kiptas7.jpeg";
import kiptas8 from "./assets/kiptas/kiptas8.jpeg";

// Marmara proje fotoğrafları
import marmara1 from "./assets/marmara/musilaj.webp";
import marmara2 from "./assets/marmara/musilaj2.webp";
import marmara3 from "./assets/marmara/musilaj3.webp";

// Dursunköy proje fotoğrafları
import dursunkoyMain from "./assets/dursunkoy-okul/dursunkoy-okul.jpeg";
import dursunkoy2 from "./assets/dursunkoy-okul/dursunkoy-okul (2).jpeg";
import dursunkoy3 from "./assets/dursunkoy-okul/dursunkoy-okul (3).jpeg";

const ProjectDetail = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState(0);
    const { id } = useParams();
    const navigate = useNavigate();

    // Proje verileri
    const projects = [
        {
            id: 1,
            title: "Üsküdar Kentsel Dönüşüm Projesi",
            category: "kentsel",
            categoryName: "Kentsel Dönüşüm",
            status: "completed",
            progress: 100,
            image: uskudar,
            location: "İstanbul, Üsküdar",
            year: "2023",
            description: "320 daireli kentsel dönüşüm projesi",
            fullDescription: "Üsküdar'ın merkezinde gerçekleştirilen bu kapsamlı kentsel dönüşüm projesi, modern şehircilik anlayışıyla tasarlanmış olup, bölgenin tarihi dokusunu koruyarak yeni nesil yaşam alanları oluşturmayı hedeflemektedir.",
            details: {
                area: "51.546,04 m²",
                units: "320 Daire",
                buildings: "10 Blok",
                duration: "24 Ay",
                client: "Emlak Konut GYO"
            },
            features: [
                "Kapalı otopark",
                "Modern mimari",
                "Çocuk oyun alanları",
                "7/24 güvenlik",
                "Sosyal tesis alanları",
                "Peyzaj bahçeleri"
            ],
            gallery: [
                uskudar, uskudar1, uskudar2, uskudar3, uskudar4, uskudar5, 
                uskudar6, uskudar7, uskudar8, uskudar9, uskudar10, uskudar11,
                uskudar12, uskudar13, uskudar14, uskudar15, uskudar16, uskudar17,
                uskudar18, uskudar19, uskudar20, uskudar21, uskudar22, uskudar23,
                uskudar24, uskudar25, uskudar26, uskudar27, uskudar28, uskudar29, 
                uskudar30, uskudar31, uskudar32, uskudar33, uskudar34, uskudar35, uskudar36
            ]
        },
        {
            id: 2,
            title: "Kartal Kentsel Dönüşüm Projesi",
            category: "kentsel",
            categoryName: "Kentsel Dönüşüm",
            status: "ongoing",
            progress: 73,
            image: kartal1,
            location: "İstanbul, Kartal",
            year: "2024",
            description: "Kartal ilçesi, orhantepe mahallesi 2.Etap kentsel dönüşüm projesi inşaatı.",
            fullDescription: "Kartal ilçesinde gerçekleştirilen bu kapsamlı kentsel dönüşüm projesi, modern şehircilik anlayışıyla tasarlanmış olup, bölgenin tarihi dokusunu koruyarak yeni nesil yaşam alanları oluşturmayı hedeflemektedir.",
            details: {
                area: "21.868,54 m²",
                units: "219 Daire",
                buildings: "14 Blok",
                duration: "24 Ay",
                client: "Emlak Konut GYO"
            },
            features: [
                "Modern mimari",
                "Kullanım alanları",
                "Açık Otopark",
                "Peyzaj bahçeleri"
            ],
            gallery: [
                kartal1, kartal2, kartal3, kartal4, kartal5, kartal6,
                kartal7, kartal8, kartal9, kartal10, kartal11, kartal12,
                kartal13, kartal14, kartal15, kartal16, kartal17, kartal18,
                kartal19, kartal20, kartal21, kartal22, kartal23, kartal24,
                kartal25, kartal26, kartal27, kartal28, kartal29, kartal30,
                kartal31, kartal32, kartal33, kartal34, kartal35, kartal36,
                kartal37, kartal38, kartal39, kartal40, kartal41
            ]
        },
        {
            id: 3,
            title: "Kiptaş Çatalca Erguvankent Konutları",
            category: "altyapi",
            categoryName: "Altyapı",
            status: "completed",
            progress: 100,
            image: kiptas1,
            location: "İstanbul, Çatalca",
            year: "2016",
            description: "Kiptaş Çatalca Erguvankent Konutları altyapı projesi.",
            fullDescription: "Çatalca Erguvankent'te gerçekleştirilen bu kapsamlı altyapı projesi, modern yaşam standartlarına uygun şekilde tasarlanmış olup, bölgenin ihtiyaçlarını karşılayan kaliteli bir altyapı sistemi oluşturulmuştur.",
            details: {
                area: "-",
                units: "-",
                buildings: "-",
                duration: "24 Ay",
                client: "İBB Yol Bakım Ve Altyapı Daire Başkanlığı"
            },
            features: [
                "Modern altyapı sistemi",
                "Yağmur suyu drenajı",
                "İçme suyu hatları",
                "Atık su sistemleri",
                "Elektrik altyapısı",
                "Doğalgaz altyapısı"
            ],
            gallery: [
                kiptas1, kiptas2, kiptas3, kiptas4, kiptas5, kiptas6, kiptas7, kiptas8
            ]
        },
        {
            id: 4,
            title: "Marmara Müsilaj Temizleme Projesi",
            category: "altyapi",
            categoryName: "Altyapı",
            status: "completed",
            progress: 100,
            image: marmara1,
            location: "Marmara Denizi",
            year: "2021",
            description: "Marmara Denizi müsilaj temizleme ve çevre koruma projesi.",
            fullDescription: "Marmara Denizi'nde gerçekleştirilen bu önemli çevre projesi kapsamında, deniz ekosisteminin korunması ve müsilaj temizliği için kapsamlı çalışmalar yürütülmüştür. Proje, deniz yaşamını koruma ve sürdürülebilir çevre yönetimi açısından büyük önem taşımaktadır.",
            details: {
                area: "-",
                units: "-",
                buildings: "-",
                duration: "12 Ay",
                client: "T.C. Çevre, Şehircilik ve İklim Değişikliği Bakanlığı"
            },
            features: [
                "Deniz yüzeyi temizliği",
                "Müsilaj toplama sistemi",
                "Çevre izleme ve raporlama",
                "Deniz ekosistemi koruma",
                "Sürdürülebilir çözümler",
                "Acil müdahale ekipleri"
            ],
            gallery: [
                marmara1, marmara2, marmara3
            ]
        },
        {
            id: 5,
            title: "Dursunköy Okul Yapımı Projesi",
            category: "ustyapi",
            categoryName: "Ustyapı",
            status: "ongoing",
            progress: 0,
            image: dursunkoyMain,
            location: "İstanbul, Dursunköy",
            year: "2026",
            description: "Dursunköy ilçesi, okul yapımı projesi inşaatı.",
            fullDescription: "Dursunköy ilçesinde gerçekleştirilen bu kapsamlı okul yapımı projesi, modern şehircilik anlayışıyla tasarlanmış olup, bölgenin ihtiyaçlarını karşılayan kaliteli bir okul yapımı projesi oluşturulmuştur.",
            details: {
                area: "14.450 m²",
                units: "40 Derslik",
                buildings: "3 Blok",
                duration: "14 Ay",
                client: "Emlak Konut GYO"
            },
            features: [
                "Modern mimari",
                "Kullanım alanları",
                
            ],
            gallery: [
                dursunkoyMain, dursunkoy2, dursunkoy3
            ]
        },

    
    ];

    const project = projects.find(p => p.id === parseInt(id));

    const openLightbox = (index) => {
        setCurrentImage(index);
        setLightboxOpen(true);
    };

    const nextImage = () => {
        if (project && project.gallery) {
            setCurrentImage((prev) => (prev + 1) % project.gallery.length);
        }
    };

    const prevImage = () => {
        if (project && project.gallery) {
            setCurrentImage((prev) => (prev - 1 + project.gallery.length) % project.gallery.length);
        }
    };

    if (!project) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white">
                <div className="text-center">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">Proje Bulunamadı</h1>
                    <Link to="/projeler" className="text-[#01346b] hover:underline">Projelere Dön</Link>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-white">
            {/* Logo */}
            <div className="hidden xl:block absolute left-[15vw] 2xl:left-[22vw] 3xl:left-[28rem] top-[60px] -translate-y-1/2 z-40 pointer-events-auto w-[80px] h-[80px] 2xl:w-[90px] 2xl:h-[90px] 3xl:w-[100px] 3xl:h-[100px] rounded-full flex items-center justify-center shrink-0 overflow-hidden shadow-xl">
                <img src={logo} alt="Logo" className="w-full h-full object-cover" />
            </div>
        
            {/* Navbar */}
            <header className="fixed top-[12px] md:top-[24px] left-0 right-0 z-50 flex items-center justify-center px-4 md:px-sm w-full pointer-events-none">
                <div className="pointer-events-auto w-full max-w-[700px] h-[60px] md:h-[72px] flex items-center justify-between bg-[#01346b] backdrop-blur-xl rounded-full px-4 md:px-xs py-xs shadow-xl border border-white/10">
                    <div className="flex items-center gap-4 pl-2 md:pl-xs">
                        <div className="md:hidden w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                            <img src={logo} alt="Logo" className="w-full h-full object-cover" />
                        </div>
                        
                        <nav className="hidden md:flex items-center gap-6 pl-4">
                            <Link to="/hakkimizda" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">Hakkımızda</Link>
                            <Link to="/projeler" className="font-label text-label text-page-bg hover:text-page-bg transition-colors duration-300">Projeler</Link>
                            <Link to="/hizmetler" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">Hizmetler</Link>
                            <Link to="/iletisim" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">İletişim</Link>
                        </nav>
                        
                        <button 
                            className="md:hidden text-white p-14"
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                            aria-label="Toggle menu"
                        >
                            {mobileMenuOpen ? (
                                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            ) : (
                                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            )}
                        </button>
                    </div>
                    <Link to="/" className="bg-page-bg text-black font-label text-sm md:text-label h-full px-4 md:px-8 rounded-full hover:bg-white transition-colors duration-300 scale-95 hover:scale-100 shrink-0 flex items-center shadow-sm">
                        Anasayfa
                    </Link>
                </div>

                <div 
                    className={`md:hidden absolute top-[72px] left-4 right-4 bg-[#01346b] backdrop-blur-xl rounded-3xl shadow-2xl border border-white/10 overflow-hidden pointer-events-auto transition-all duration-500 ease-out ${
                        mobileMenuOpen 
                            ? 'opacity-100 translate-y-0 max-h-96' 
                            : 'opacity-0 -translate-y-4 max-h-0 pointer-events-none'
                    }`}
                >
                    <nav className="flex flex-col p-4">
                        <Link to="/hakkimizda" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Hakkımızda</Link>
                        <Link to="/projeler" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Projeler</Link>
                        <Link to="/hizmetler" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Hizmetler</Link>
                        <Link to="/iletisim" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>İletişim</Link>
                    </nav>
                </div>
            </header>

            {/* Hero Section */}
            <section className="relative pt-28 md:pt-32 lg:pt-40 pb-12 md:pb-16 lg:pb-20 overflow-hidden">
                {/* Background Image */}
                <div className="absolute inset-0">
                    <img 
                        src={project.image} 
                        alt={project.title}
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-br from-[#01346b]/95 via-[#01346b]/90 to-[#024a8f]/95"></div>
                </div>

                {/* Decorative Elements */}
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
                    <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
                </div>

                <div className="max-w-[1200px] mx-auto px-4 md:px-8 relative z-10">
                    <button 
                        onClick={() => navigate(-1)}
                        className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-6 md:mb-8 transition-colors duration-300 group"
                    >
                        <svg className="w-4 h-4 md:w-5 md:h-5 group-hover:-translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                        </svg>
                        <span className="font-medium text-sm md:text-base">Geri Dön</span>
                    </button>

                    <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-4 md:mb-6">
                        <span className={`px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold ${
                            project.status === 'completed' 
                                ? 'bg-emerald-500 text-white' 
                                : 'bg-amber-500 text-white'
                        }`}>
                            {project.status === 'completed' ? 'Tamamlandı' : 'Devam Ediyor'}
                        </span>
                        <span className="px-3 md:px-4 py-1.5 md:py-2 bg-white/20 backdrop-blur-md rounded-full text-xs md:text-sm font-bold text-white">
                            {project.categoryName}
                        </span>
                    </div>

                    <h1 className="font-display text-2xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight break-words">
                        {project.title}
                    </h1>
                    
                    <div className="flex flex-wrap items-center gap-3 md:gap-6 text-white/90 text-base md:text-lg">
                        <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                            <span className="font-medium text-sm md:text-base break-words">{project.location}</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                            <span className="font-medium text-sm md:text-base">{project.year}</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Main Content */}
            <section className="py-12 md:py-16 lg:py-24 bg-[#f8f9fa]">
                <div className="max-w-[1400px] mx-auto px-4 md:px-8">
                    <div className="grid lg:grid-cols-12 gap-6 md:gap-8 lg:gap-12">
                        {/* Sidebar */}
                        <div className="lg:col-span-4 space-y-6">
                            {/* Progress Ring Card */}
                            <div className="bg-white rounded-3xl p-6 md:p-8 shadow-lg border border-gray-100">
                                <h3 className="font-display text-lg md:text-xl font-bold text-gray-900 mb-6 md:mb-8 text-center">
                                    Proje Durumu
                                </h3>
                                
                                {/* Progress Ring */}
                                <div className="relative w-40 h-40 md:w-48 md:h-48 mx-auto mb-6 md:mb-8">
                                    <svg className="transform -rotate-90 w-40 h-40 md:w-48 md:h-48">
                                        <circle
                                            cx="80"
                                            cy="80"
                                            r="72"
                                            stroke="#e5e7eb"
                                            strokeWidth="10"
                                            fill="none"
                                            className="md:hidden"
                                        />
                                        <circle
                                            cx="96"
                                            cy="96"
                                            r="88"
                                            stroke="#e5e7eb"
                                            strokeWidth="12"
                                            fill="none"
                                            className="hidden md:block"
                                        />
                                        <circle
                                            cx="80"
                                            cy="80"
                                            r="72"
                                            stroke="url(#gradient)"
                                            strokeWidth="10"
                                            fill="none"
                                            strokeDasharray={`${2 * Math.PI * 72}`}
                                            strokeDashoffset={`${2 * Math.PI * 72 * (1 - project.progress / 100)}`}
                                            strokeLinecap="round"
                                            className="transition-all duration-1000 md:hidden"
                                        />
                                        <circle
                                            cx="96"
                                            cy="96"
                                            r="88"
                                            stroke="url(#gradient)"
                                            strokeWidth="12"
                                            fill="none"
                                            strokeDasharray={`${2 * Math.PI * 88}`}
                                            strokeDashoffset={`${2 * Math.PI * 88 * (1 - project.progress / 100)}`}
                                            strokeLinecap="round"
                                            className="transition-all duration-1000 hidden md:block"
                                        />
                                        <defs>
                                            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                                <stop offset="0%" stopColor="#01346b" />
                                                <stop offset="100%" stopColor="#024a8f" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                    <div className="absolute inset-0 flex flex-col items-center justify-center">
                                        <span className="text-4xl md:text-5xl font-bold text-[#01346b]">{project.progress}%</span>
                                        <span className="text-xs md:text-sm text-gray-500 mt-1 md:mt-2">Tamamlandı</span>
                                    </div>
                                </div>

                                {/* Technical Details */}
                                <div className="space-y-3 md:space-y-4 pt-6 border-t border-gray-200">
                                    <h4 className="font-display text-base md:text-lg font-bold text-gray-900 mb-3 md:mb-4">
                                        Teknik Detaylar
                                    </h4>
                                    {Object.entries(project.details).map(([key, value]) => (
                                        <div key={key} className="flex flex-col gap-1 py-2">
                                            <span className="text-gray-600 font-medium capitalize text-sm md:text-base">
                                                {key === 'area' && 'Alan'}
                                                {key === 'units' && 'Birim'}
                                                {key === 'buildings' && 'Blok'}
                                                {key === 'duration' && 'Süre'}
                                                {key === 'client' && 'Müşteri'}
                                            </span>
                                            <span className="text-gray-900 font-bold text-sm md:text-base break-words leading-relaxed">{value}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Main Content */}
                        <div className="lg:col-span-8 space-y-8 md:space-y-12">
                            {/* Description */}
                            <div className="bg-white rounded-3xl p-6 md:p-8 lg:p-10 shadow-lg border border-gray-100">
                                <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-[#01346b] mb-4 md:mb-6">
                                    Proje Hakkında
                                </h2>
                                <p className="text-gray-700 text-base md:text-lg leading-relaxed">
                                    {project.fullDescription}
                                </p>
                            </div>

                            {/* Features */}
                            <div className="bg-white rounded-3xl p-6 md:p-8 lg:p-10 shadow-lg border border-gray-100">
                                <h3 className="font-display text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6">
                                    Özellikler
                                </h3>
                                <div className="grid md:grid-cols-2 gap-3 md:gap-4">
                                    {project.features.map((feature, idx) => (
                                        <div key={idx} className="flex items-start gap-3 bg-gradient-to-br from-gray-50 to-white rounded-2xl p-3 md:p-4 hover:shadow-md transition-all duration-300 border border-gray-100">
                                            <div className="w-8 h-8 md:w-10 md:h-10 bg-gradient-to-br from-[#01346b] to-[#024a8f] rounded-xl flex items-center justify-center flex-shrink-0">
                                                <svg className="w-4 h-4 md:w-5 md:h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                                </svg>
                                            </div>
                                            <span className="text-gray-700 font-medium pt-1 md:pt-2 text-sm md:text-base">{feature}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Gallery */}
                            {project.gallery && project.gallery.length > 0 && (
                                <div className="bg-white rounded-3xl p-6 md:p-8 lg:p-10 shadow-lg border border-gray-100">
                                    <h3 className="font-display text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6">
                                        Proje Görselleri
                                    </h3>
                                    <div className="grid md:grid-cols-2 gap-4 md:gap-6">
                                        {project.gallery.map((img, idx) => (
                                            <div 
                                                key={idx} 
                                                className="relative rounded-2xl overflow-hidden group aspect-video cursor-pointer"
                                                onClick={() => openLightbox(idx)}
                                            >
                                                <img 
                                                    src={img} 
                                                    alt={`${project.title} ${idx + 1}`}
                                                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                                                />
                                                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                                                    <div className="w-12 h-12 bg-white/0 group-hover:bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                                                        <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            {/* Lightbox Modal */}
            {lightboxOpen && project.gallery && (
                <div className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in">
                    <button 
                        onClick={() => setLightboxOpen(false)}
                        className="absolute top-4 right-4 w-12 h-12 bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center text-white transition-colors duration-300 z-10"
                    >
                        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>

                    <button 
                        onClick={prevImage}
                        className="absolute left-4 w-12 h-12 bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center text-white transition-colors duration-300"
                    >
                        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>

                    <button 
                        onClick={nextImage}
                        className="absolute right-4 w-12 h-12 bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center text-white transition-colors duration-300"
                    >
                        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                        </svg>
                    </button>

                    <div className="max-w-6xl w-full">
                        <img 
                            src={project.gallery[currentImage]} 
                            alt={`${project.title} ${currentImage + 1}`}
                            className="w-full h-auto max-h-[90vh] object-contain rounded-2xl"
                        />
                        <div className="text-center mt-4">
                            <span className="text-white/80 text-sm">
                                {currentImage + 1} / {project.gallery.length}
                            </span>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                @keyframes fade-in {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }

                .animate-fade-in {
                    animation: fade-in 0.3s ease-out;
                }
            `}</style>
        </div>
    );
};

export default ProjectDetail;
